// some features, some of them used directly in html (see twig templates)
export function welcomeBlocStartCloseButtonAction(StartButtonTitle, CloseButtonTitle, FieldReceivingFocus, xitiname) {
    var StartContent = StartButtonTitle.concat(' <span class="glyphicon glyphicon-menu-down"></span>');
    var CloseContent = CloseButtonTitle.concat(' <span class="glyphicon glyphicon-menu-up"></span>');
    var ButtonContent = document.getElementById('ButtonOpenClose').innerHTML;
    if (ButtonContent == StartContent) {
        ButtonOpenClose.innerHTML = CloseContent;
        $("#Bloc_demarrer").attr("checked", false);
        $("#ButtonOpenClose").attr("data-xiti-name", xitiname);
        var str = $("#ButtonOpenClose").attr("data-xiti-name");
        var res = str.replace("demarrer", "fermer");
        $("#ButtonOpenClose").attr("data-xiti-name", res);
        document.getElementById('Bloc_demarrer').click();
        if ((FieldReceivingFocus) != "") { document.getElementById(FieldReceivingFocus).focus(); }
    }
    if (ButtonContent == CloseContent) {
        ButtonOpenClose.innerHTML = StartContent;
        $("#Bloc_demarrer").attr("checked", true);
        var str = $("#ButtonOpenClose").attr("data-xiti-name");
        var res = str.replace("fermer", "demarrer");
        $("#ButtonOpenClose").attr("data-xiti-name", res);
        document.getElementById('Bloc_demarrer').click();
    }
    return true;
}

export function AfficherMasquer() {
    divInfo = document.getElementById('divacacher');

    if (divInfo.style.display == 'none')
        divInfo.style.display = 'block';
    else
        divInfo.style.display = 'none';
}

export function AfficherMasquerHelpBefor() {
    divBefore = document.getElementById('helpbefor');

    if (divBefore.style.display == 'none')
        divBefore.style.display = 'block';
    else
        divBefore.style.display = 'none';
}

export function endOfDownloadNotifications() {
    document.cookie = "fileDownload=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    var simulatorEvaluateUrlButton = decodeURIComponent(decodeURIComponent(sessionStorage.getItem('simulatorEvaluateUrlButton')));
    if (simulatorEvaluateUrlButton !== "") {
        var blocButtonEvaluate = '<div id="blocButtonEvaluate" class="evaluate_button_bloc" style="display: none;"> <a href="' + simulatorEvaluateUrlButton + '" target="_blank"><img src="https://voxusagers.numerique.gouv.fr/static/bouton-bleu.svg" alt="Je donne mon avis - Service-Publics+" />	</div>';
        $('#js_action_buttons').before(blocButtonEvaluate);
        $('#blocButtonEvaluate').fadeIn("slow");
    }
}